import { render, staticRenderFns } from "./BuildPeopleFilterModal.vue?vue&type=template&id=037fa0c8&scoped=true&"
import script from "./BuildPeopleFilterModal.vue?vue&type=script&lang=js&"
export * from "./BuildPeopleFilterModal.vue?vue&type=script&lang=js&"
import style0 from "./BuildPeopleFilterModal.vue?vue&type=style&index=0&id=037fa0c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037fa0c8",
  null
  
)

export default component.exports